import { setApplicationStateById } from '@/contexts/ApplicationContext/ApplicationContext';

export const setShowSummary = (setState: setApplicationStateById) => (showSummary: boolean) => {
  setState('SET_SHOW_SUMMARY', (s) => ({
    ...s,
    showSummary,
  }));
};
